/*
 * @Author: Huangjiajia
 * @Description: 路由
 * @Date: 2025-02-05 11:34:05
 * @LastEditors: hjj
 * @LastEditTime: 2025-03-03 15:59:54
 * @FilePath: /beiye_project/src/router/index.js
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/business',
    name: 'business',
    component: () => import('../views/business/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about/index.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
